var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-vertical-steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step-item",class:{
        'active': index === _vm.activeIndex,
        'completed': index < _vm.activeIndex,
        'last-item': index === _vm.steps.length - 1
    }},[(index !== _vm.steps.length - 1)?_c('div',{staticClass:"step-connector"}):_vm._e(),_c('div',{staticClass:"step-icon"}),_c('div',{staticClass:"step-content"},[_c('div',{staticClass:"step-title"},[_vm._v(_vm._s(step.title))]),_c('div',{staticClass:"step-description"},[_vm._v(_vm._s(step?.description))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }